/*
 *   File : reward-point.js
 *   Author : https://evoqins.com
 *   Description : Reward Point component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useRef, useState } from 'react';


//Custom component
import { DataTableComponent } from '../../../Component/DataTable';
import { APIService } from '../../../Service';
import { EmptyScreen } from '../../../Component/EmptyComponent';
import { Loader } from '../../../Component/Others';

const ITEMS_PER_PAGE = 15;

const PAGE_SORT_FIELDS = [
    'total_unit',
    'category',
    'product',
    'date',
];

const RewardPoint = (props) => {

    const tableRef = useRef(null);
    const isSortingRef = useRef(false);
    const skipListFetchRef = useRef(false);

    const [salesData, setSalesData] = useState({});
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);

    const [sortField, setSortField] = useState(null);
    const [sortDirection, setSortDirection] = useState(null);

    useEffect(() => {
        if (skipListFetchRef.current) {
            skipListFetchRef.current = false;
            return;
        }
        _getSalesData();
    }, [currentPage, props.adminId]);

    // handle page change of table
    const _handlePageChange = (page_num) => {
        if (isSortingRef.current) {
            isSortingRef.current = false;
            return;
        }

        if (page_num === currentPage) {
            return;
        }

        setCurrentPage(page_num);
        setLoading(true);

        if (tableRef.current) {
            tableRef.current.scrollIntoView({ behavior: 'smooth', block: "start" });
        }
    };

    const _handleSort = (column, direction) => {
        const sortBy = column.sortField || column.id || null;

        if (!sortBy || !PAGE_SORT_FIELDS.includes(sortBy)) {
            return;
        }

        isSortingRef.current = true;
        setSortField(sortBy);
        setSortDirection(direction);
        setLoading(true);

        // Only skip the list useEffect when page will actually change.
        if (currentPage !== 1) {
            skipListFetchRef.current = true;
        }
        setCurrentPage(1);
        _getSalesData(1, sortBy, direction);

        setTimeout(() => {
            isSortingRef.current = false;
        }, 0);
    };

    // sales and reward table
    const TABLE_COLUMNS = [
        {
            name: 'Total unit sales',
            id: 'total_unit',
            sortField: 'total_unit',
            selector: row => row.total_unit,
            width: "160px",
            sortable: true,
        },
        {
            name: 'Category',
            id: 'category',
            sortField: 'category',
            selector: row => row.category,
            width: "160px",
            sortable: true,
        },
        {
            name: 'Linked products',
            id: 'product',
            sortField: 'product',
            selector: row => row.product,
            width: "280px",
            sortable: true,
        },
        {
            name: "Reward points",
            selector: row => row.point === null ?
                "-"
                :
                row.point
        }
    ];

    // API - Get sales and reward data
    const _getSalesData = (page_num = currentPage, sort_by = sortField, sort_order = sortDirection) => {
        const effective_sort_by = sort_by && PAGE_SORT_FIELDS.includes(sort_by) ? sort_by : null;
        const effective_sort_order = effective_sort_by ? sort_order : null;

        let is_post = true;
        let url = 'country-admin/sales';
        let data = {
            "admin_id": props.adminId,
            "page_num": page_num,
            "limit": ITEMS_PER_PAGE,
            "sort_by": effective_sort_by ? [effective_sort_by] : null,
            "order": effective_sort_order ? [effective_sort_order] : null,
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setSalesData(response.data);
            } else { }
            setLoading(false);
        });
    };

    return (
        <>
            {/* Reward points/ sales table */}
            <div ref={tableRef} className='e-bg-white e-admin-box-shadow py-4 e-border-radius-16 '>
                <div className='px-4'>
                    <h4 className='mb-0 e-text-rich-black e-alt-font-noto-sans e-font-20 e-font-weight-600 line-height-28px'>
                        Reward points/ sales
                    </h4>
                </div>

                {loading ?
                    // loader 
                    <Loader />
                    :
                    <>
                        {/* Data table */}
                        {salesData.data.length !== 0 ?
                            <div className='e-table'>
                                <DataTableComponent
                                    key={`reward-sales-${currentPage}-${sortField || 'none'}-${sortDirection || 'none'}`}
                                    columns={TABLE_COLUMNS}
                                    pagination={true}
                                    data={salesData.data}
                                    paginationServer={true}
                                    paginationPerPage={ITEMS_PER_PAGE}
                                    paginationTotalRows={salesData.total_count}
                                    paginationDefaultPage={currentPage}
                                    paginationResetDefaultPage={false}
                                    sortServer={true}
                                    defaultSortFieldId={sortField}
                                    defaultSortAsc={sortDirection !== 'desc'}
                                    onSort={_handleSort}
                                    onChangePage={_handlePageChange} />
                            </div>
                            :
                            // empty screen
                            <div className='h-100vh pt-5 mt-5'>
                                <EmptyScreen message="No data found" />
                            </div>
                        }
                    </>
                }
            </div>
        </>
    )
}

export default RewardPoint;
